import React, { Component } from 'react';
import Loading from 'components/Loading/Loading';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { resumeMembership } from 'actions/userActions';
import './style.css';

class Reactivate extends Component {
  handleResume = () => {
    const { user } = this.props;

    if (user && user.stripeCustomerId) {
      this.props.resumeMembership(user.stripeCustomerId, null, () => {
        browserHistory.push('/payment-failure');
      });
    }
  }

  render() {
    const { error, resumeStatus, user } = this.props;

    return (
      <div className="Reactivate text-center text-white">
        <h3 className="reactivate-title">Reactivate your membership</h3>
        <div className="my-4">
          {user.paused && (
            <p className="my-0">
              Your membership is currently on pause until{' '}
              {moment(user.pause.endDate).format('MMMM DD, YYYY')}.
            </p>
          )}
          <p className="my-0">Click &#39;Reactivate&#39; below to continue booking your lessons now.</p>
        </div>
        {resumeStatus === 'LOADING' ? (
          <Loading />
        ) : (
          <button type="button" className="btn btn-lg btn-primary btn-cursor" onClick={this.handleResume}>
            Reactivate
          </button>
        )}
        {resumeStatus === 'FAIL' && (
          <p className="my-2 text-danger">{error.message || 'Something went wrong.'}</p>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.profile,
    resumeStatus: state.user.resumeStatus,
    error: state.user.error
  };
}

export default connect(
  mapStateToProps,
  { resumeMembership }
)(Reactivate);



// WEBPACK FOOTER //
// ./src/pages/student/Reactivate/index.js